import Model from './Model';

import SeoTag from './SeoTag';

import MissingTranslationArticleResponse from 'Api/CRM/Responses/MissingTranslationArticleResponse';

export default class MissingTranslationArticle extends Model {
    readonly id: number;
    readonly language_id: number;
    readonly translation_id: number | null;
    readonly lottery_id: number | null;
    readonly title: string;
    readonly is_title_hidden: boolean | null = false;
    readonly slug: string;
    readonly mobile_slug: string | null;
    readonly text: string | null;
    readonly no_deletable: boolean;
    readonly no_index: boolean;
    readonly is_partial: boolean;
    readonly is_blog: boolean | null;
    readonly is_casino_page: boolean;
    readonly publication_date: string | null;
    readonly created_at: string | null;
    readonly updated_at: string | null;
    readonly timezone: string | null;
    readonly missing_languages: string;
    readonly seo_tag: SeoTag | null;

    constructor(model: Partial<MissingTranslationArticleResponse>) {
        super();

        this.assignDataToProps(model, [
            'id',
            'language_id',
            'translation_id',
            'lottery_id',
            'title',
            'is_title_hidden',
            'slug',
            'mobile_slug',
            'text',
            'no_deletable',
            'no_index',
            'is_partial',
            'is_blog',
            'is_casino_page',
            'missing_languages',
            'publication_date',
            'created_at',
            'updated_at',
            'timezone',
            'seo_tag',
        ]);
    }
}
